module.exports = __webpack_public_path__ + "img/currey-and-company.91beae8.jpg";